import { Container } from "../Container";
import { WebGLGrayscaleShader } from "tree2d";
import { ensureFloat } from "../../utils/TypeUtils";
export class Grayscale extends Container {
    constructor(stage) {
        super(stage);
        this.shader = new WebGLGrayscaleShader(this.stage.context);
        this.el.renderToTexture = true;
        this.el.shader = this.shader;
    }
    get amount() {
        return this.shader.amount;
    }
    set amount(v) {
        this.shader.amount = ensureFloat(v);
    }
}
//# sourceMappingURL=Grayscale.js.map